import { find } from 'lodash';
import { isDesktop } from 'react-device-detect';
import { getConfig } from '../../util/configUtil';

export const CENTRAL_PAGE_PATH = '/home';

export const MODULE_NAMES = {
    MESSAGES: 'messages',
    APPOINTMENTS: 'appointments',
    PATIENTS: 'patients',
    PATIENT_DASHBOARD: 'patientDashboard',
    ADD_PATIENT: 'addPatient',
    PATIENT_FILTERS: 'patientFilters',
    CPP_DASHBOARD: 'cppDashboard',
    WARD_VIEW: 'wardView',
    HOLDING_PEN: 'holdingPen',
    SEARCH: 'search',
    AUDITS: 'audits',
    COMPLETE_AUDITS: 'completeAudits',
    BED_MANAGEMENT: 'bedManagement',
    BED_BOOKING: 'bedBooking',
    ADM_WORK_LIST: 'admWorkList',
    FHIR_DASHBOARD: 'fhirDashboard',
    ADMIN: 'admin',
    ADMIT_PATIENT: 'admitPatient',
    EXTERNAL_MANAGMENT: 'externalManagment',
    EXTERNAL_MANAGMENT_REFRESH: 'externalManagmentRefresh',
    REGISTRATION: 'registration',
    EXTENDED_DASHBOARD: 'extendedDashboard',
    EXTENDED_DASHBOARD_MANAGEMENT: 'externalDashboardManagment',
    MAIN_VIEW: 'mainView',
    BOOK_ADMISSION: 'bookAdmission',
    BOOKED_ADMISSION: 'bookedAdmission',
    BOOKED_ADMISSIONS_DASHBOARD: 'bookedAdmissionDashboard',
    CLEANING_REQUEST: 'cleaningRequest',
    ESTIMATED_WAITING_TIME: 'estimatedWaitingTime',
    CENTRAL_PAGE: 'centralPage',
    SCHEDULER: 'scheduler',
    SUPPORT_SERVICES: 'supportServices',
    PATIENT_REGISTRY: 'patientRegistry',
    MCT: 'mct',
    TREATMENT_BOARD: 'treatmentBoard',
    TREATMENT_BOARD_MANAGEMENT: 'treatmentBoardManagement',
    EWT_BOARD: 'ewtBoard',
    EWT_BOARD_MANAGEMENT: 'ewtBoardManagement',
    REFERRAL: 'referral',
    MEDICATIONS_MODULE: 'medicationsModule',
};

// Move to DB => dict.agyleModules;
export const AVAILABLE_MODULES = [
    {
        id: 'admin',
        name: MODULE_NAMES.ADMIN,
        description: 'Administration',
        componentPath: '/admin',
        openNewCard: false,
        devices: ['desktop', 'mobile', 'iPad'],
        enabled: getConfig('adminModuleEnabled', false),
        iconName: 'adminModule',
    },
    {
        id: 'externalManagmentRefresh',
        name: MODULE_NAMES.EXTERNAL_MANAGMENT_REFRESH,
        description: 'ADT',
        componentPath: '/eadmitRefresh',
        openNewCard: false,
        devices: ['desktop', 'mobile', 'iPad'],
        enabled: getConfig('externalManagment.enabled', false),
        iconName: 'adtModule',
    },
    {
        id: 'audits',
        name: MODULE_NAMES.AUDITS,
        description: 'Audit',
        componentPath: '/audits',
        openNewCard: false,
        devices: ['desktop', 'mobile', 'iPad'],
        enabled: true,
        iconName: 'auditModule',
    },
    {
        id: 'bedBooking',
        name: MODULE_NAMES.BED_BOOKING,
        description: 'Flow (Lite)',
        componentPath: '/bedBooking',
        openNewCard: false,
        devices: ['desktop', 'mobile', 'iPad'],
        enabled: true,
        iconName: 'flowModule',
    },
    {
        id: 'bedManagement',
        name: MODULE_NAMES.BED_MANAGEMENT,
        description: 'Flow',
        devices: ['desktop', 'mobile', 'iPad'],
        componentPath: '/bedManagement',
        openNewCard: false,
        enabled: getConfig('modules.bedManagement.enabled', false),
        iconName: 'flowModule',
    },
    {
        id: 'referral',
        name: MODULE_NAMES.REFERRAL,
        description: 'Referral',
        devices: ['desktop', 'mobile', 'iPad'],
        componentPath: '/referral',
        openNewCard: false,
        enabled: getConfig('referralFlowEnabled', false),
        iconName: 'referralModule',
    },
    {
        id: 'bookAdmission',
        name: MODULE_NAMES.BOOK_ADMISSION,
        description: 'Book Admission',
        componentPath: '/bookAdmission',
        openNewCard: false,
        devices: ['desktop', 'mobile', 'iPad'],
        enabled: getConfig('bookAdmissionModuleEnabled', false) && isDesktop,
        iconName: 'bookingModule',
    },
    {
        id: 'bookedAdmissionsDashboard',
        name: MODULE_NAMES.BOOKED_ADMISSIONS_DASHBOARD,
        devices: ['desktop', 'mobile', 'iPad'],
        description: 'Booked Admissions Dashboard',
        componentPath: '/bookedAdmissionsDashboard',
        openNewCard: false,
        enabled: getConfig('bookAdmissionModuleEnabled', false) && isDesktop,
        iconName: 'bookingModule',
    },
    {
        id: 'cleaningRequest',
        name: MODULE_NAMES.CLEANING_REQUEST,
        devices: ['desktop', 'mobile', 'iPad'],
        description: 'Cleaning',
        componentPath: '/report/cleaningRequest',
        openNewCard: false,
        enabled: getConfig('modules.cleaningRequest.enabled', false),
    },
    {
        id: 'support',
        name: MODULE_NAMES.SUPPORT_SERVICES,
        devices: ['desktop', 'mobile', 'iPad'],
        description: 'Support',
        componentPath: getConfig('modules.centralPage.supportURL', ''),
        openNewCard: true,
        enabled: getConfig('modules.centralPage.supportTabEnabled', false),
        iconName: 'supportModule',
    },
    {
        id: 'estimatedWaitingTime',
        name: MODULE_NAMES.ESTIMATED_WAITING_TIME,
        devices: ['desktop', 'mobile', 'iPad'],
        description: 'ED Wait',
        componentPath: (hospitalId) => `/report/estimatedTime/${hospitalId}`,
        openNewCard: false,
        enabled: false,
        iconName: 'edWaitModule',
    },
    {
        id: 'extendedDashboard',
        name: MODULE_NAMES.EXTENDED_DASHBOARD,
        description: 'Insight (Lite)',
        devices: ['desktop', 'mobile', 'iPad'],
        componentPath: '/insight/live-dashboard',
        openNewCard: false,
        enabled: getConfig('modules.insightDashboard.liveDashboard', false),
        iconName: 'insightModule',
    },
    {
        id: 'extendedDashboardManagement',
        name: MODULE_NAMES.EXTENDED_DASHBOARD_MANAGEMENT,
        description: 'Insight (Lite) Settings',
        devices: ['desktop', 'mobile', 'iPad'],
        componentPath: '/insight/live-dashboard-management',
        openNewCard: false,
        enabled: getConfig('modules.insightDashboard.liveDashboard', false),
        iconName: 'insightModule',
        cornerIcon: 'adminModule',
    },
    {
        id: 'fhirDashboard',
        name: MODULE_NAMES.FHIR_DASHBOARD,
        description: 'FHIR Dashboard',
        componentPath: '/fhirDashboard',
        openNewCard: false,
        devices: ['desktop', 'mobile', 'iPad'],
        enabled: false,
    },
    {
        id: 'holdingPen',
        name: MODULE_NAMES.HOLDING_PEN,
        description: 'Holding Pen',
        componentPath: '/holding',
        openNewCard: false,
        devices: ['desktop', 'mobile', 'iPad'],
        enabled: false,
    },
    {
        id: 'search',
        name: MODULE_NAMES.SEARCH,
        description: 'Smart Search',
        componentPath: '/search',
        openNewCard: false,
        devices: ['desktop', 'mobile', 'iPad'],
        enabled: true,
        iconName: 'smartSearchModule',
    },
    {
        id: 'registration',
        name: MODULE_NAMES.REGISTRATION,
        description: 'Registration',
        componentPath: '/registration',
        openNewCard: false,
        devices: ['desktop', 'mobile', 'iPad'],
        enabled: false,
    },
    {
        id: 'patientRegistry',
        name: MODULE_NAMES.PATIENT_REGISTRY,
        description: 'Registration',
        componentPath: '/registry',
        openNewCard: false,
        devices: ['desktop', 'mobile', 'iPad'],
        enabled: getConfig('admitPatient.registration', false),
        iconName: 'registerModule',
    },
    {
        id: 'patientAppointments',
        name: MODULE_NAMES.SCHEDULER,
        description: 'Scheduler',
        componentPath: '/scheduler',
        openNewCard: false,
        devices: ['desktop'],
        enabled: getConfig('modules.scheduler.enabled', false),
        iconName: 'schedulerModule',
    },
    {
        id: 'wardView',
        name: MODULE_NAMES.WARD_VIEW,
        description: 'Whiteboard',
        componentPath: '/wards',
        openNewCard: false,
        enabled: getConfig('modules.wardCreator.enabled', false),
        devices: ['desktop', 'mobile', 'iPad'],
        iconName: 'whiteboardModule',
    },
    {
        id: 'admWorkList',
        name: MODULE_NAMES.ADM_WORK_LIST,
        description: 'Work List',
        componentPath: '/admWorkList',
        openNewCard: false,
        devices: ['desktop', 'mobile', 'iPad'],
        enabled: false,
    },
    {
        id: 'tutorials',
        name: 'tutorials',
        description: 'Resources',
        devices: ['desktop', 'mobile', 'iPad'],
        componentPath: '/training',
        openNewCard: false,
        enabled: false,
        iconName: 'resourcesModule',
    },
    {
        id: 'mct',
        name: MODULE_NAMES.MCT,
        description: 'Creator',
        devices: ['desktop', 'iPad'],
        componentPath: '/wards',
        openNewCard: false,
        enabled: getConfig('modules.wardCreator.enabled', false),
        iconName: 'mctModule',
    },
    {
        id: 'treatmentBoard',
        name: MODULE_NAMES.TREATMENT_BOARD,
        description: 'Treatment Board',
        devices: ['desktop', 'iPad'],
        componentPath: '/insight/boards',
        openNewCard: false,
        enabled: getConfig('modules.insightDashboard.treatmentBoard', false),
        iconName: 'treatmentBoard',
    },
    {
        id: 'treatmentBoardManagement',
        name: MODULE_NAMES.TREATMENT_BOARD_MANAGEMENT,
        description: 'Treatment Board Settings',
        devices: ['desktop', 'iPad'],
        componentPath: '/insight/management-boards',
        openNewCard: false,
        enabled: getConfig('modules.insightDashboard.treatmentBoard', false),
        iconName: 'treatmentBoard',
        cornerIcon: 'adminModule',
    },
    {
        id: 'ewtBoard',
        name: MODULE_NAMES.EWT_BOARD,
        description: 'Estimated Waiting Time Board',
        devices: ['desktop', 'iPad'],
        componentPath: '/insight/ewt-board',
        openNewCard: false,
        enabled: getConfig('modules.insightDashboard.ewtDashboard', false),
        iconName: 'estimWaitBoard',
    },
    {
        id: 'ewtBoardManagement',
        name: MODULE_NAMES.EWT_BOARD_MANAGEMENT,
        description: 'Estimated Waiting Time Settings',
        devices: ['desktop', 'iPad'],
        componentPath: '/insight/ewt-board-admin',
        openNewCard: false,
        enabled: getConfig('modules.insightDashboard.ewtDashboard', false),
        iconName: 'estimWaitBoard',
        cornerIcon: 'adminModule',
    },
    {
        id: 'medicationsModule',
        name: MODULE_NAMES.MEDICATIONS_MODULE,
        description: 'Medications Module',
        devices: ['desktop'],
        componentPath: '/medications',
        openNewCard: false,
        enabled: getConfig('modules.forms.prescription.externalVersion', false),
        iconName: 'medicationsModule',
    },
    {
        id: 'completeAudits',
        name: MODULE_NAMES.COMPLETE_AUDITS,
        description: 'Complete Audits',
        componentPath: '/completeAudits',
        openNewCard: false,
        devices: ['desktop', 'mobile', 'iPad'],
        enabled: getConfig('modules.audits.newAuditEnabled', false),
        iconName: 'auditModule',
    },
];

export const getModulePath = (moduleName) => {
    const module = find(AVAILABLE_MODULES, { name: moduleName });

    if (module) {
        return module.componentPath;
    }

    return CENTRAL_PAGE_PATH;
};

export const MODULE_PATHS = {
    [MODULE_NAMES.SCHEDULER]: `${getModulePath(MODULE_NAMES.SCHEDULER)}`,
    [MODULE_NAMES.PATIENT_REGISTRY]: getModulePath(MODULE_NAMES.PATIENT_REGISTRY),
    [MODULE_NAMES.ESTIMATED_WAITING_TIME]: getModulePath(MODULE_NAMES.ESTIMATED_WAITING_TIME),
    [MODULE_NAMES.MEDICATIONS_MODULE]: getModulePath(MODULE_NAMES.MEDICATIONS_MODULE),
};
